"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.56,13.8a.29.29,0,0,0-.23-.11H19a2.15,2.15,0,0,0-2.35-2.08,2.28,2.28,0,0,0-.75.13,3.57,3.57,0,0,0-6.81,0,2.3,2.3,0,0,0-.75-.13A2.13,2.13,0,0,0,6,13.69H5.66a.29.29,0,0,0-.23.11.28.28,0,0,0-.07.24l1,6a1.72,1.72,0,0,0,1.11,1.31c0-.07,0-.13,0-.2a2.08,2.08,0,1,1,4.16,0,1.61,1.61,0,0,1,0,.3h1.83a1.61,1.61,0,0,1,0-.3,2.08,2.08,0,0,1,4.16,0c0,.07,0,.13,0,.2A1.7,1.7,0,0,0,18.64,20l1-6A.28.28,0,0,0,19.56,13.8Zm-13-.11a1.54,1.54,0,0,1,1.76-1.49,1.71,1.71,0,0,1,.82.2.32.32,0,0,0,.27,0,.3.3,0,0,0,.16-.21,3,3,0,0,1,5.83,0,.3.3,0,0,0,.16.21.32.32,0,0,0,.27,0,1.71,1.71,0,0,1,.82-.2,1.55,1.55,0,0,1,1.76,1.49Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "9.53",
    cy: "21.13",
    r: "1.49",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "15.47",
    cy: "21.13",
    r: "1.49",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.5,2.39a12.5,12.5,0,0,0-11,18.39.52.52,0,0,0,.92-.49,11.46,11.46,0,1,1,20.21,0,.52.52,0,0,0,.21.7.51.51,0,0,0,.25.06.52.52,0,0,0,.46-.27,12.5,12.5,0,0,0-11-18.39Zm-5,1.89A11.72,11.72,0,0,0,2.16,20.41a.26.26,0,0,1-.11.35.27.27,0,0,1-.12,0,.26.26,0,0,1-.23-.14A12.24,12.24,0,0,1,7.29,3.81a.26.26,0,1,1,.22.47Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;